import { z } from "zod";

export const putProfileAvatarResolverSchema = z.object({
	profileImage: z.string(),
});